export const BRAND_NAME = "Vault";
export const BRAND_ACCENT = "line";
export const BRAND_FULL = "Vaultline";

export const PRODUCT_BADGE = "Business banking";

export const META_DESCRIPTION =
  "Vaultline helps you manage cash, send and receive money, and use virtual cards — securely, from one dashboard.";

export const HERO_TITLE = "Banking that keeps your money moving.";

export const HERO_TEXT =
  "Open an account in minutes. See balances in real time, pay people and businesses, and spend with virtual cards — without juggling multiple tools.";

export const HERO_FEATURES = [
  "Cash accounts with live balance updates",
  "Virtual cards for online and team spending",
  "Send, receive, and withdraw on your schedule",
];

export const AUTH_MOBILE_INTRO = "Sign in to your account";

export const SIGNUP_SUBTITLE =
  "Get started with your name, email, and password. We'll set up your account automatically.";

export const SIGNIN_SUBTITLE = "Sign in to continue to your dashboard.";
